import { FitType, IFormInteractionHandler } from './IFormInteractionHandler';

export class TableFormInteractionHandler implements IFormInteractionHandler {
    getCurrentPage(): number {
        return 1;
    }

    getTotalPages(): number {
        return 1;
    }

    goToPage(_: number): void {
        // Tables don't have pages
    }

    goToPreviousPage(): void {
        // Tables don't have pages
    }

    goToNextPage(): void {
        // Tables don't have pages
    }

    goToFirstPage(): void {
        // Tables don't have pages
    }

    goToLastPage(): void {
        // Tables don't have pages
    }

    zoomIn(): number {
        // Tables don't support zoom
        return 1;
    }

    zoomOut(): number {
        // Tables don't support zoom
        return 1;
    }

    zoomTo(_: number): void {
        // Tables don't support zoom
    }

    fitToPage(): void {
        // Tables don't support fit
    }

    fitToWidth(): void {
        // Tables don't support fit
    }

    fitToAuto(): void {
        // Tables don't support fit
    }

    getCurrentFitType(): FitType {
        return null;
    }
}
